import React, { useState } from 'react';
import { usePage, Link, useForm, router } from '@inertiajs/react';
import { ArrowLeft, Eye, UploadCloud, Download, Check, AlertTriangle, FileSpreadsheet, XCircle, Trash2, Plus, RefreshCw } from 'lucide-react';
import MobilePreview from '../../components/MobilePreview';

const COUNTRY_CODES = [
  { c: "AF", n: "+93" }, { c: "AL", n: "+355" }, { c: "DZ", n: "+213" }, { c: "AS", n: "+1-684" }, { c: "AD", n: "+376" }, { c: "AO", n: "+244" }, { c: "AI", n: "+1-264" }, { c: "AQ", n: "+672" }, { c: "AG", n: "+1-268" }, { c: "AR", n: "+54" }, { c: "AM", n: "+374" }, { c: "AW", n: "+297" }, { c: "AU", n: "+61" }, { c: "AT", n: "+43" }, { c: "AZ", n: "+994" }, { c: "BS", n: "+1-242" }, { c: "BH", n: "+973" }, { c: "BD", n: "+880" }, { c: "BB", n: "+1-246" }, { c: "BY", n: "+375" }, { c: "BE", n: "+32" }, { c: "BZ", n: "+501" }, { c: "BJ", n: "+229" }, { c: "BM", n: "+1-441" }, { c: "BT", n: "+975" }, { c: "BO", n: "+591" }, { c: "BA", n: "+387" }, { c: "BW", n: "+267" }, { c: "BR", n: "+55" }, { c: "IO", n: "+246" }, { c: "VG", n: "+1-284" }, { c: "BN", n: "+673" }, { c: "BG", n: "+359" }, { c: "BF", n: "+226" }, { c: "BI", n: "+257" }, { c: "KH", n: "+855" }, { c: "CM", n: "+237" }, { c: "CA", n: "+1" }, { c: "CV", n: "+238" }, { c: "KY", n: "+1-345" }, { c: "CF", n: "+236" }, { c: "TD", n: "+235" }, { c: "CL", n: "+56" }, { c: "CN", n: "+86" }, { c: "CX", n: "+61" }, { c: "CC", n: "+61" }, { c: "CO", n: "+57" }, { c: "KM", n: "+269" }, { c: "CK", n: "+682" }, { c: "CR", n: "+506" }, { c: "HR", n: "+385" }, { c: "CU", n: "+53" }, { c: "CW", n: "+599" }, { c: "CY", n: "+357" }, { c: "CZ", n: "+420" }, { c: "CD", n: "+243" }, { c: "DK", n: "+45" }, { c: "DJ", n: "+253" }, { c: "DM", n: "+1-767" }, { c: "DO", n: "+1-809" }, { c: "TL", n: "+670" }, { c: "EC", n: "+593" }, { c: "EG", n: "+20" }, { c: "SV", n: "+503" }, { c: "GQ", n: "+240" }, { c: "ER", n: "+291" }, { c: "EE", n: "+372" }, { c: "ET", n: "+251" }, { c: "FK", n: "+500" }, { c: "FO", n: "+298" }, { c: "FJ", n: "+679" }, { c: "FI", n: "+358" }, { c: "FR", n: "+33" }, { c: "PF", n: "+689" }, { c: "GA", n: "+241" }, { c: "GM", n: "+220" }, { c: "GE", n: "+995" }, { c: "DE", n: "+49" }, { c: "GH", n: "+233" }, { c: "GI", n: "+350" }, { c: "GR", n: "+30" }, { c: "GL", n: "+299" }, { c: "GD", n: "+1-473" }, { c: "GU", n: "+1-671" }, { c: "GT", n: "+502" }, { c: "GG", n: "+44-1481" }, { c: "GN", n: "+224" }, { c: "GW", n: "+245" }, { c: "GY", n: "+592" }, { c: "HT", n: "+509" }, { c: "HN", n: "+504" }, { c: "HK", n: "+852" }, { c: "HU", n: "+36" }, { c: "IS", n: "+354" }, { c: "IN", n: "+91" }, { c: "ID", n: "+62" }, { c: "IR", n: "+98" }, { c: "IQ", n: "+964" }, { c: "IE", n: "+353" }, { c: "IM", n: "+44-1624" }, { c: "IL", n: "+972" }, { c: "IT", n: "+39" }, { c: "CI", n: "+225" }, { c: "JM", n: "+1-876" }, { c: "JP", n: "+81" }, { c: "JE", n: "+44-1534" }, { c: "JO", n: "+962" }, { c: "KZ", n: "+7" }, { c: "KE", n: "+254" }, { c: "KI", n: "+686" }, { c: "XK", n: "+383" }, { c: "KW", n: "+965" }, { c: "KG", n: "+996" }, { c: "LA", n: "+856" }, { c: "LV", n: "+371" }, { c: "LB", n: "+961" }, { c: "LS", n: "+266" }, { c: "LR", n: "+231" }, { c: "LY", n: "+218" }, { c: "LI", n: "+423" }, { c: "LT", n: "+370" }, { c: "LU", n: "+352" }, { c: "MO", n: "+853" }, { c: "MK", n: "+389" }, { c: "MG", n: "+261" }, { c: "MW", n: "+265" }, { c: "MY", n: "+60" }, { c: "MV", n: "+960" }, { c: "ML", n: "+223" }, { c: "MT", n: "+356" }, { c: "MH", n: "+692" }, { c: "MR", n: "+222" }, { c: "MU", n: "+230" }, { c: "YT", n: "+262" }, { c: "MX", n: "+52" }, { c: "FM", n: "+691" }, { c: "MD", n: "+373" }, { c: "MC", n: "+377" }, { c: "MN", n: "+976" }, { c: "ME", n: "+382" }, { c: "MS", n: "+1-664" }, { c: "MA", n: "+212" }, { c: "MZ", n: "+258" }, { c: "MM", n: "+95" }, { c: "NA", n: "+264" }, { c: "NR", n: "+674" }, { c: "NP", n: "+977" }, { c: "NL", n: "+31" }, { c: "AN", n: "+599" }, { c: "NC", n: "+687" }, { c: "NZ", n: "+64" }, { c: "NI", n: "+505" }, { c: "NE", n: "+227" }, { c: "NG", n: "+234" }, { c: "NU", n: "+683" }, { c: "KP", n: "+850" }, { c: "MP", n: "+1-670" }, { c: "NO", n: "+47" }, { c: "OM", n: "+968" }, { c: "PK", n: "+92" }, { c: "PW", n: "+680" }, { c: "PS", n: "+970" }, { c: "PA", n: "+507" }, { c: "PG", n: "+675" }, { c: "PY", n: "+595" }, { c: "PE", n: "+51" }, { c: "PH", n: "+63" }, { c: "PN", n: "+64" }, { c: "PL", n: "+48" }, { c: "PT", n: "+351" }, { c: "PR", n: "+1-787" }, { c: "QA", n: "+974" }, { c: "CG", n: "+242" }, { c: "RE", n: "+262" }, { c: "RO", n: "+40" }, { c: "RU", n: "+7" }, { c: "RW", n: "+250" }, { c: "BL", n: "+590" }, { c: "SH", n: "+290" }, { c: "KN", n: "+1-869" }, { c: "LC", n: "+1-758" }, { c: "MF", n: "+590" }, { c: "PM", n: "+508" }, { c: "VC", n: "+1-784" }, { c: "WS", n: "+685" }, { c: "SM", n: "+378" }, { c: "ST", n: "+239" }, { c: "SA", n: "+966" }, { c: "SN", n: "+221" }, { c: "RS", n: "+381" }, { c: "SC", n: "+248" }, { c: "SL", n: "+232" }, { c: "SG", n: "+65" }, { c: "SX", n: "+1-721" }, { c: "SK", n: "+421" }, { c: "SI", n: "+386" }, { c: "SB", n: "+677" }, { c: "SO", n: "+252" }, { c: "ZA", n: "+27" }, { c: "KR", n: "+82" }, { c: "SS", n: "+211" }, { c: "ES", n: "+34" }, { c: "LK", n: "+94" }, { c: "SD", n: "+249" }, { c: "SR", n: "+597" }, { c: "SJ", n: "+47" }, { c: "SZ", n: "+268" }, { c: "SE", n: "+46" }, { c: "CH", n: "+41" }, { c: "SY", n: "+963" }, { c: "TW", n: "+886" }, { c: "TJ", n: "+992" }, { c: "TZ", n: "+255" }, { c: "TH", n: "+66" }, { c: "TG", n: "+228" }, { c: "TK", n: "+690" }, { c: "TO", n: "+676" }, { c: "TT", n: "+1-868" }, { c: "TN", n: "+216" }, { c: "TR", n: "+90" }, { c: "TM", n: "+993" }, { c: "TC", n: "+1-649" }, { c: "TV", n: "+688" }, { c: "VI", n: "+1-340" }, { c: "UG", n: "+256" }, { c: "UA", n: "+380" }, { c: "AE", n: "+971" }, { c: "GB", n: "+44" }, { c: "US", n: "+1" }, { c: "UY", n: "+598" }, { c: "UZ", n: "+998" }, { c: "VU", n: "+678" }, { c: "VA", n: "+379" }, { c: "VE", n: "+58" }, { c: "VN", n: "+84" }, { c: "WF", n: "+681" }, { c: "EH", n: "+212" }, { c: "YE", n: "+967" }, { c: "ZM", n: "+260" }, { c: "ZW", n: "+263" }
].sort((a, b) => a.c.localeCompare(b.c));

interface PageProps {
  invitation: any;
  invitationUsers: any[];
  totalUsersCount: number;
}

export default function ImportUsers() {
  const { invitation, invitationUsers, totalUsersCount } = usePage<PageProps>().props;
  const [activeTab, setActiveTab] = useState<'excel'|'manual'>('excel');
  const [selectedPreviewIdx, setSelectedPreviewIdx] = useState(0);
  const locale = (usePage().props as any).locale || 'en';

  const { data, setData, post, processing, errors, progress } = useForm({
    file: null as File | null,
  });

  const [manualData, setManualData] = useState({ name: '', phone_code: '+966', phone_number: '', organization: '' });
  const [manualLoading, setManualLoading] = useState(false);

  const submitManual = () => {
    if (!manualData.name || !manualData.phone_number) return;
    setManualLoading(true);
    router.post(`/${locale}/invitations/${invitation.id}/add_user`, {
      invitation_user: {
        name: manualData.name,
        phone_number: `${manualData.phone_code}${manualData.phone_number.replace(/^0+/, '')}`,
        organization: manualData.organization
      }
    }, {
      preserveScroll: true,
      onFinish: () => setManualLoading(false),
      onSuccess: () => {
        setManualData({ ...manualData, name: '', phone_number: '', organization: '' });
        setActiveTab('excel'); // Optional: switch tab or just show success
      }
    });
  };

  const getStatusStyle = (status: string) => {
    switch(status?.toLowerCase()) {
       case 'valid': return 'bg-green-50 text-green-700 border-green-200';
       case 'duplicate': return 'bg-orange-50 text-orange-700 border-orange-200';
       case 'invalid': return 'bg-red-50 text-red-700 border-red-200';
       case 'pending': return 'bg-blue-50 text-blue-700 border-blue-200';
       case 'sent': return 'bg-green-100 text-green-800 border-green-300';
       default: return 'bg-gray-50 text-gray-700 border-gray-200';
    }
  };

  const selectedUser = invitationUsers?.[selectedPreviewIdx];
  const currentPreviewBody = selectedUser 
    ? `Hello ${selectedUser.name},\n\nYou are warmly invited to our exclusive event of the year.\n\nThank you!`
    : 'Select an invitee to preview their invitation.';

  return (
    <div className="bg-[#f8f9fa] min-h-screen pb-10">
      {/* Top Navigation */}
      <div className="bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between sticky top-0 z-50 shadow-sm">
        <Link href={`/invitations`} className="flex items-center text-gray-600 hover:text-gray-900 font-medium">
          <ArrowLeft className="w-5 h-5 mr-2" />
          Back
        </Link>
        <h1 className="text-xl font-bold text-gray-800">Import Invitees & Generate Personalized Invitations</h1>
        <button className="flex items-center text-gray-600 hover:text-gray-900 border border-gray-300 bg-white rounded-md px-4 py-2 text-sm font-medium shadow-sm transition">
          <Eye className="w-4 h-4 mr-2" />
          Preview
        </button>
      </div>

      <div className="max-w-screen-2xl mx-auto py-6 px-6 flex gap-6">
        
        {/* Main Content Area (Left) */}
        <div className="flex-1 space-y-6">
          
          {/* Section 1: Import Method */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
             <div className="px-6 py-3 flex items-center border-b border-gray-100 bg-gray-50/50">
               <div className="bg-[#0f766e] text-white w-6 h-6 rounded-full flex items-center justify-center text-sm font-bold mr-3 shrink-0">1</div>
               <h2 className="text-[15px] font-semibold text-[#0f766e] mr-6 shrink-0">Import Method</h2>
               
               <div className="flex space-x-2">
                 <button onClick={() => setActiveTab('manual')} className={`px-4 py-1.5 text-sm font-medium rounded-md transition ${activeTab === 'manual' ? 'bg-white shadow-sm border border-gray-200 text-gray-800' : 'text-gray-500 hover:text-gray-700'}`}>Manual Entry</button>
                 <button onClick={() => setActiveTab('excel')} className={`px-4 py-1.5 text-sm font-medium rounded-md transition ${activeTab === 'excel' ? 'bg-[#0f766e] text-white shadow-sm border border-[#0f766e]' : 'text-gray-500 hover:text-gray-700'}`}>Excel Upload</button>
               </div>
             </div>
             
             <div className="p-6">
               {activeTab === 'excel' && (
                 <div className="space-y-4">
                    <label className={`border-2 border-dashed rounded-lg p-6 flex flex-col items-center justify-center relative cursor-pointer transition ${errors.file ? 'border-red-400 bg-red-50' : 'border-gray-300 bg-gray-50/50 hover:bg-gray-50'}`}>
                       <input type="file" className="hidden" accept=".xlsx,.xls,.csv" onChange={e => {
                         if (e.target.files && e.target.files[0]) {
                           setData('file', e.target.files[0]);
                         }
                       }} />
                       <UploadCloud className="w-10 h-10 text-[#0f766e] mb-2" />
                       <h3 className="text-gray-800 font-semibold mb-1">Upload Excel File</h3>
                       <p className="text-gray-500 text-sm mb-4">Use the structured template to import invitees in bulk</p>
                       <p className="text-xs text-gray-400">Click to browse your files</p>
                    </label>
                    {errors.file && <p className="text-red-500 text-xs font-medium">{errors.file}</p>}

                    {/* Uploaded File State */}
                    {data.file && (
                    <div className="flex items-center justify-between bg-white border border-gray-200 rounded-lg p-4 shadow-sm">
                       <div className="flex items-center">
                          <div className="bg-green-100 p-2 rounded mr-3">
                             <FileSpreadsheet className="w-5 h-5 text-green-600" />
                          </div>
                          <div>
                             <h4 className="font-semibold text-gray-800 text-sm">{data.file.name}</h4>
                             {progress && (
                               <progress value={progress.percentage} max="100" className="w-full h-1 mt-1">
                                 {progress.percentage}%
                               </progress>
                             )}
                          </div>
                       </div>
                       <div className="flex items-center space-x-4">
                          <button className="text-gray-400 hover:text-red-500 transition" onClick={(e) => { e.preventDefault(); setData('file', null); }}>
                             <Trash2 className="w-5 h-5" />
                          </button>
                       </div>
                    </div>
                    )}
                 </div>
               )}
             </div>
          </div>

          {/* Section 2: Invitee Data & Fields */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
             <div className="px-6 py-3 flex items-center border-b border-gray-100 bg-gray-50/50">
               <div className="bg-[#0f766e] text-white w-6 h-6 rounded-full flex items-center justify-center text-sm font-bold mr-3">2</div>
               <h2 className="text-[15px] font-semibold text-[#0f766e]">Invitee Data & Fields</h2>
             </div>
             
             <div className="p-6">
                <div className="grid grid-cols-2 gap-8 mb-6">
                   <div>
                      <h3 className="font-semibold text-gray-800 mb-3 text-sm flex items-center">Required Fields <span className="text-red-500 ml-1">*</span></h3>
                      <ul className="space-y-2">
                         {['Full Name', 'Mobile Number', 'Country Code', 'Invitation Variables'].map(f => (
                            <li key={f} className="flex items-center text-sm text-gray-600">
                               <Check className="w-4 h-4 text-green-500 mr-2" /> {f}
                            </li>
                         ))}
                      </ul>
                   </div>
                   <div>
                      <h3 className="font-semibold text-gray-800 mb-3 text-sm">Optional Fields</h3>
                      <div className="grid grid-cols-2 gap-y-2">
                         {['Email', 'Company', 'Job Title', 'Custom Variables', 'Category', 'Guest Type'].map(f => (
                            <div key={f} className="flex items-center text-sm text-gray-600">
                               <div className="w-1.5 h-1.5 rounded-full bg-[#0f766e] mr-2"></div> {f}
                            </div>
                         ))}
                      </div>
                   </div>
                </div>

                <div className="pt-6 border-t border-gray-100">
                   <h3 className="font-semibold text-gray-800 mb-3 text-sm">Add One Invitee Manually</h3>
                   <div className="flex items-end space-x-4">
                      <div className="flex-1">
                         <label className="block text-xs font-semibold text-gray-600 mb-1">Full Name <span className="text-red-500">*</span></label>
                         <input type="text" placeholder="e.g. John Doe" className="w-full rounded-md border-gray-300 shadow-sm focus:border-[#0f766e] focus:ring-[#0f766e] text-sm px-3 py-2 bg-gray-50/50" />
                      </div>
                      <div className="flex-1">
                         <label className="block text-xs font-semibold text-gray-600 mb-1">Mobile Number <span className="text-red-500">*</span></label>
                         <div className="flex">
                            <select className="rounded-l-md border-gray-300 shadow-sm focus:border-[#0f766e] focus:ring-[#0f766e] text-sm px-2 py-2 bg-gray-50/50 border-r-0 text-gray-600 w-24">
                               <option>+65</option>
                            </select>
                            <input type="text" placeholder="8123 4567" className="flex-1 rounded-r-md border-gray-300 shadow-sm focus:border-[#0f766e] focus:ring-[#0f766e] text-sm px-3 py-2 bg-gray-50/50" />
                         </div>
                      </div>
                      <div className="flex-1">
                         <label className="block text-xs font-semibold text-gray-600 mb-1">Company</label>
                         <input type="text" placeholder="e.g. Acme Corp" className="w-full rounded-md border-gray-300 shadow-sm focus:border-[#0f766e] focus:ring-[#0f766e] text-sm px-3 py-2 bg-gray-50/50" />
                      </div>
                      <button className="bg-[#0f766e] hover:bg-[#0d645e] text-white font-medium py-2 px-6 rounded-md shadow-sm transition text-sm whitespace-nowrap h-[38px]">
                         Add Invitee
                      </button>
                   </div>
                </div>
             </div>
          </div>

          {/* Section 3: Validation & Processing */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
             <div className="px-6 py-3 flex items-center border-b border-gray-100 bg-gray-50/50">
               <div className="bg-[#0f766e] text-white w-6 h-6 rounded-full flex items-center justify-center text-sm font-bold mr-3">3</div>
               <h2 className="text-[15px] font-semibold text-[#0f766e]">Validation & Processing</h2>
             </div>
             
             <div className="p-6">
                <div className="grid grid-cols-2 gap-8">
                   
                   {/* Left: Validation Summary */}
                   <div>
                      <h3 className="font-semibold text-gray-800 mb-3 text-sm">Validation Summary</h3>
                      <div className="space-y-2 text-sm">
                         {totalUsersCount > 0 ? (
                           <>
                             <div className="flex items-center justify-between py-2 border-b border-gray-100">
                                <span className="flex items-center text-gray-600"><Check className="w-4 h-4 text-green-500 mr-2"/> Imported Users</span>
                                <div className="flex items-center">
                                   <span className="font-semibold mr-3 text-base">{totalUsersCount}</span>
                                   <span className="text-[10px] bg-green-100 text-green-800 px-1.5 py-0.5 rounded font-bold uppercase">Success</span>
                                </div>
                             </div>
                             <div className="flex items-center justify-between py-2 border-b border-gray-100">
                                <span className="flex items-center text-gray-600"><AlertTriangle className="w-4 h-4 text-blue-400 mr-2"/> Showing in Preview</span>
                                <div className="flex items-center">
                                   <span className="font-semibold mr-3">{invitationUsers?.length || 0}</span>
                                </div>
                             </div>
                           </>
                         ) : (
                           <div className="py-4 text-center text-gray-500">
                              Upload an Excel file to see validation results.
                           </div>
                         )}
                      </div>
                   </div>

                   {/* Right: Next Steps */}
                   <div className="border border-[#0f766e]/20 rounded-lg p-5 bg-teal-50/30 relative flex flex-col justify-center">
                      <div className="mb-2">
                         <h3 className="font-semibold text-[#0f766e] text-sm mb-2">Ready to Send?</h3>
                         <p className="text-xs text-gray-600 leading-relaxed">
                           Once your file is uploaded and validated, you can proceed to the Preview step to begin sending invitations to your <strong>{totalUsersCount}</strong> invitees.
                         </p>
                      </div>
                   </div>
                </div>

                <div className="mt-6 flex space-x-3">
                   <button 
                     onClick={() => post(`/${locale}/invitations/${invitation.id}/upload_users`)} 
                     disabled={!data.file || processing}
                     className="bg-white border border-[#0f766e] text-[#0f766e] hover:bg-teal-50 font-medium py-2 px-6 rounded-md shadow-sm transition text-sm flex items-center disabled:opacity-50">
                      <Check className="w-4 h-4 mr-2" /> {processing ? 'Uploading...' : 'Upload & Validate File'}
                   </button>
                   <Link 
                     href={`/${locale}/invitations/${invitation.id}/preview`}
                     className="bg-[#0f766e] hover:bg-[#0d645e] text-white font-medium py-2 px-6 rounded-md shadow-sm transition text-sm flex items-center">
                      Continue to Preview
                   </Link>
                </div>
             </div>
          </div>

          {/* Section 4: Invitee Preview */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
             <div className="px-6 py-3 flex items-center border-b border-gray-100 bg-gray-50/50">
               <div className="bg-[#0f766e] text-white w-6 h-6 rounded-full flex items-center justify-center text-sm font-bold mr-3">4</div>
               <h2 className="text-[15px] font-semibold text-[#0f766e]">Invitee Preview</h2>
             </div>
             
             <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                   <thead className="bg-white">
                      <tr>
                         <th className="px-6 py-3 text-left text-[11px] font-bold text-gray-500 uppercase tracking-wider w-16">#</th>
                         <th className="px-6 py-3 text-left text-[11px] font-bold text-gray-500 uppercase tracking-wider">Name</th>
                         <th className="px-6 py-3 text-left text-[11px] font-bold text-gray-500 uppercase tracking-wider">Mobile</th>
                         <th className="px-6 py-3 text-left text-[11px] font-bold text-gray-500 uppercase tracking-wider">Company</th>
                         <th className="px-6 py-3 text-left text-[11px] font-bold text-gray-500 uppercase tracking-wider">Status</th>
                         <th className="px-6 py-3 text-left text-[11px] font-bold text-gray-500 uppercase tracking-wider text-right">Preview</th>
                      </tr>
                   </thead>
                   <tbody className="bg-white divide-y divide-gray-100">
                      {invitationUsers?.map((user, idx) => (
                         <tr key={user.id} className={`transition cursor-pointer ${selectedPreviewIdx === idx ? 'bg-teal-50/50' : 'hover:bg-gray-50'}`} onClick={() => setSelectedPreviewIdx(idx)}>
                            <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-500">{idx + 1}</td>
                            <td className="px-6 py-3 whitespace-nowrap text-sm font-medium text-gray-900">{user.name || '-'}</td>
                            <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-600 font-mono">{user.phone_number || '-'}</td>
                            <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-600">{user.organization || '-'}</td>
                            <td className="px-6 py-3 whitespace-nowrap">
                               <span className={`px-2.5 py-0.5 inline-flex text-[11px] leading-5 font-bold rounded border ${getStatusStyle(user.status || 'pending')}`}>
                                 {user.status || 'Pending'}
                               </span>
                            </td>
                            <td className="px-6 py-3 whitespace-nowrap text-right">
                               <button 
                                 className={`flex items-center justify-center p-1.5 rounded-full ml-auto transition ${selectedPreviewIdx === idx ? 'bg-[#0f766e] text-white' : 'text-gray-400 hover:text-[#0f766e] hover:bg-teal-50'}`}
                                 onClick={(e) => { e.stopPropagation(); setSelectedPreviewIdx(idx); }}
                               >
                                  <Eye className="w-4 h-4" />
                               </button>
                            </td>
                         </tr>
                      ))}
                      {(!invitationUsers || invitationUsers.length === 0) && (
                         <tr>
                            <td colSpan={6} className="px-6 py-8 text-center text-gray-500">
                               No invitees found. Upload an Excel file or add one manually.
                            </td>
                         </tr>
                      )}
                   </tbody>
                </table>
             </div>
             
             {/* Pagination */}
             <div className="px-6 py-4 border-t border-gray-100 flex items-center justify-between bg-white">
                <p className="text-sm text-gray-500">Showing <span className="font-medium text-gray-900">{invitationUsers?.length || 0}</span> of <span className="font-medium text-gray-900">{totalUsersCount || 0}</span> invitees</p>
                <div className="flex space-x-1">
                   <button className="px-2 py-1 border border-gray-300 text-gray-500 rounded hover:bg-gray-50 disabled:opacity-50" disabled>&lt;</button>
                   <button className="px-3 py-1 bg-[#0f766e] text-white font-medium rounded border border-[#0f766e]">1</button>
                   <button className="px-2 py-1 border border-gray-300 text-gray-500 rounded hover:bg-gray-50 disabled:opacity-50" disabled>&gt;</button>
                </div>
             </div>

          </div>

        </div>

        {/* Right Sidebar: Mobile Preview */}
        <div className="w-[380px] shrink-0">
          <div className="sticky top-28 bg-white border border-gray-100 p-6 rounded-xl shadow-sm">
            <div className="flex justify-between items-center mb-2">
               <h3 className="font-bold text-[#0f766e] text-lg">Per-Invitee Preview</h3>
               <span className="text-[10px] uppercase tracking-wider font-bold text-gray-400 bg-gray-100 px-2 py-1 rounded">Preview</span>
            </div>
            <p className="text-xs text-gray-500 mb-6">This shows the generated invitation for the selected invitee.</p>
            
            <div className="flex justify-center transform scale-[0.9] origin-top">
              <MobilePreview 
                headerName="Acme Events"
                messageBody={currentPreviewBody}
                buttons={["Yes, I'll attend", "Unable to attend"]}
              />
            </div>
            
            <div className="mt-6 bg-[#f8f9fa] border border-blue-100 p-3 rounded-lg flex items-start text-xs text-blue-800 shadow-sm">
               <div className="w-4 h-4 rounded-full border border-blue-300 flex items-center justify-center mr-2 flex-shrink-0 bg-white text-blue-500 font-bold">i</div>
               <p>Preview uses data from the currently selected invitee. Switch selection in the table to preview others.</p>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}
